export default __webpack_public_path__ + "static/media/Aws.e4e78c9b.png";